import { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return !!(params.get('token_hash') && params.get('type'));
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenHash = params.get('token_hash');
    const type = params.get('type');
    if (!tokenHash || !type) return;

    supabase.auth.verifyOtp({ token_hash: tokenHash, type: type as any })
      .then(({ error }) => {
        if (error) {
          navigate('/auth/login?error=confirmation_failed', { replace: true });
        } else {
          navigate('/', { replace: true });
        }
      })
      .finally(() => setVerifying(false));
  }, [navigate]);

  if (loading || verifying) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="w-10 h-10 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
}
